// import 'current-script-polyfill'
import "@babel/polyfill"
import Vue from 'vue'
import App from '@/App.vue'
import 'Components'
import router from '@/router'
import store from '@/vuex/store'


// Load in the correct css
// let carrier = window.location.host.split('.')[1] ? window.location.host.split('.')[0] : false;
// carrier = carrier ? carrier.toLowerCase() : '';

// let partnerEnvironment = process.env.VUE_APP_PARTNER_ENVIRONMENT;

if (process.env.VUE_APP_PARTNER_ENVIRONMENT && process.env.VUE_APP_PARTNER_ENVIRONMENT === 'ee' && process.env.VUE_APP_ENVIRONMENT === 'production') {
  window.location.replace('https://wefix.co.uk');
}

if (process.env.VUE_APP_PARTNER_ENVIRONMENT) {
  require('@/styles/core/whitelabel/'+process.env.VUE_APP_PARTNER_ENVIRONMENT+'.scss');
} else {
  require('@/styles/core/whitelabel/wefix.scss');
}

window.Vue = Vue;

Vue.config.productionTip = false;

// Boostrap.
import BootstrapVue from 'bootstrap-vue'
Vue.use(BootstrapVue);

// Google Maps
import * as VueGoogleMaps from 'vue2-google-maps'
Vue.use(VueGoogleMaps, {
  load: {
    key: 'AIzaSyBdZcrpWfXStW2Uui8iweJYvwCv18xvrYg',
    libraries: 'places', // This is required if you use the Autocomplete plugin
  }
});

//User
import User from "./services/user";
let user = new User(store.getters.user);

// Vee Validate
import { ValidationObserver, ValidationProvider } from 'vee-validate';
Vue.component('ValidationObserver', ValidationObserver);
Vue.component('ValidationProvider', ValidationProvider);

// Vue Scrollto
let VueScrollTo = require('vue-scrollto');
Vue.use(VueScrollTo, {
  container: "body",
  duration: 250,
  easing: "ease-in",
  offset: -20,
  force: true,
  cancelable: true,
  onStart: false,
  onDone: false,
  onCancel: false,
  x: false,
  y: true
});


// Vue Toasted
import VueToasted from 'vue-toasted';
Vue.use(VueToasted, {
  iconPack: 'custom-class' // set your iconPack, defaults to material. material|fontawesome|custom-class
});

// VueAxios
import Axios from 'axios';
let axios = Axios.create({
  baseURL: process.env.VUE_APP_API_URI,
  headers: {
      Authorization: `Bearer ${user.apiKey()}`,
      Accept: 'application/json'
  }
});

axios.interceptors.request.use((config) => {
  config.params = config.params || {};
  config.params['key'] = user.apiKey();
  return config;
});

// Add global error handling for standard errors.
axios.interceptors.response.use((response) => {
  // Pass through.
  return Promise.resolve(response)
}, (error) => {
  if (!error.config.bypassErrorCheck || (error.config.bypassErrorCheck && error.config.bypassErrorCheck === false)) {
    store.dispatch('handleResponseErrors', error);
  }
  return Promise.reject(error)
});

Vue.prototype.$http = axios;
store.$axios = axios;

/**
 * Google analytics
 */
import VueGtag from "vue-gtag";

// Handle absence of property, for when we don't want to record analytics (local, sandbox, etc)
if (process.env.VUE_APP_ANALYTICS_TOKEN !== undefined
    && process.env.VUE_APP_ANALYTICS_TOKEN !== null
    && process.env.VUE_APP_ANALYTICS_TOKEN !== '') {

    Vue.use(VueGtag, {
        config: {id: process.env.VUE_APP_ANALYTICS_TOKEN}
    }, router);

}

import '@/registerServiceWorker'

new Vue({
  router,
  store,
  render: h => h(App),
}).$mount('#app')
